import { createSelector } from 'reselect'

import { MR_ONBOARDING_WIZARD } from './constants'

const featureRootSelector = ({ meetingIntelligence }) => meetingIntelligence

const acknowledgementModalSelector = createSelector(
  featureRootSelector,
  ({ acknowledgementModal }) => acknowledgementModal
)

const recordingRulesModalSelector = createSelector(
  featureRootSelector,
  ({ recordingRulesModal }) => recordingRulesModal
)

const autoShareDiscoveryModalSelector = createSelector(
  featureRootSelector,
  ({ autoShareDiscoveryModal }) => autoShareDiscoveryModal
)

const loadingModalSelector = createSelector(
  featureRootSelector,
  ({ loadingModal }) => loadingModal
)

const wizardOnboardingSelector = createSelector(
  featureRootSelector,
  ({ onboardingWizardSlice }) => onboardingWizardSlice
)

export const shouldShowAcknowledgementModalSelector = createSelector(
  acknowledgementModalSelector,
  ({ showModal }) => showModal
)

export const shouldShowRecordingRulesModalSelector = createSelector(
  recordingRulesModalSelector,
  ({ showModal }) => showModal
)

export const shouldShowAutoShareDiscoveryModalSelector = createSelector(
  autoShareDiscoveryModalSelector,
  ({ showModal }) => showModal
)

export const shouldShowAcknowledgementLoadingModalSelector = createSelector(
  loadingModalSelector,
  ({ showAcknowledgementLoadingModal }) => showAcknowledgementLoadingModal
)

export const acknowledgementRedirectDestinationSelector = createSelector(
  loadingModalSelector,
  ({ acknowledgementRedirectDestination }) => acknowledgementRedirectDestination
)

export const shouldShowRecordingRulesLoadingModalSelector = createSelector(
  loadingModalSelector,
  ({ showRecordingRulesLoadingModal }) => showRecordingRulesLoadingModal
)

export const getAcknowledgementModalIsUserTriggered = createSelector(
  acknowledgementModalSelector,
  ({ type }) => type === MR_ONBOARDING_WIZARD.USER_TRIGGERED
)

export const getIsUserFreeEmail = createSelector(
  wizardOnboardingSelector,
  ({ isFreeEmail }) => isFreeEmail
)

export const shouldShowReminderSpotlight = createSelector(
  wizardOnboardingSelector,
  ({ showReminderSpotlight }) => showReminderSpotlight
)

export const shouldShowAutoShareSpotlightSelector = createSelector(
  autoShareDiscoveryModalSelector,
  ({ showSpotlight }) => showSpotlight
)

export const autoShareSpotlightTypeSelector = createSelector(
  autoShareDiscoveryModalSelector,
  ({ spotlightType }) => spotlightType
)
